import React from 'react'
// import { Link } from 'react-router-dom'
import Particles from 'react-particles'
import particleConfig from './particleConfig'

const ErrorFallback = ({ errorMessage }) =>  
    <>
        <Particles className={'particlesWrapper'} options={particleConfig} />
        <section className="section">
            <div className="error">
                <h3 className="title is-4">Something went wrong...</h3>
                <p>{errorMessage}</p>
                {/* <Link
                    className="button"
                    // onClick={() => resetError()}
                    to={{
                        pathname: `/`,
                    }}
                >
                    Return Home
                </Link> */}
            </div>
        </section>
    </>

export default ErrorFallback
